export const environment = {
  production: false,
  apiUrl: 'https://api-dia.planwise-dev.roche.com',
};
